// Consultation request endpoint — Packet 4.5B.
// Thin wrapper around `api` (shared axios instance with withCredentials).
// Backend route: POST /api/consultations/request (live since P4.5A / f002216).
import { api } from "../api";

export const submitConsultationRequest = async (payload) =>
  (await api.post("/consultations/request", payload)).data;
